import Tabs from 'components/Tabs';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const StoreTabs = () => {
  const { storeNo } = useParams();

  const baseUrl = useMemo(() => `/manage-stores/${storeNo}/`, [storeNo]);

  const tabs = useMemo(
    () => [
      {
        path: `${baseUrl}products`,
        label: 'Products',
      },
      { path: `${baseUrl}sales`, label: 'Sales' },
      {
        path: `${baseUrl}sale-orders`,
        label: 'SaleOrders',
      },
      {
        path: `${baseUrl}inventory-locations`,
        label: 'InventoryLocations.titleClean',
      },
      {
        path: `${baseUrl}inventory-placement`,
        label: 'InventoryPlacement',
      },
      {
        path: `${baseUrl}inventory`,
        label: 'InventoryCount',
      },
      {
        path: `${baseUrl}validation`,
        label: 'Validation',
      },
    ],
    [baseUrl],
  );
  return <Tabs tabs={tabs} />;
};

export default StoreTabs;
